import { Box, Button, DialogActions, DialogContent, Divider } from '@mui/material';
import { CustomDialog } from '../../components/CustomDialog';
import { CustomDialogTitle } from '@repo-foundation/components/CustomDialogTitle';

export interface TutorPageGuideDialogProps {
  open: boolean;
  onClose: () => void;
}

export function TutorPageGuideDialog(props: TutorPageGuideDialogProps) {
  const { open, onClose } = props;
  return (
    <CustomDialog open={open} onClose={onClose} className="TutorPageGuideDialog-root">
      <CustomDialogTitle title="TutorPageGuideDialog" onClose={onClose} />
      <Divider />
      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            minWidth: 340,
            width: '100%',
            height: 200,
            p: 5,
          }}
        >
          TutorPageGuideDialog
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>닫기</Button>
      </DialogActions>
    </CustomDialog>
  );
}
